module.exports = __webpack_public_path__ + "staticcomp/img/content_4.942c993.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/11/content_4.jpg
// module id = tZxZ
// module chunks = 39